import Component from '@glimmer/component';
import type { ContactCustomPropertyInfo } from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  existingPropertyInfos: ContactCustomPropertyInfo[];
  contentClass?: string; // can add a max height class to the content area
  onExistingPropertySelected: (info: ContactCustomPropertyInfo) => void;
  onNewPropertySelected: () => void;
}

export default class ContactCustomPropertyAddSelectExistingOrNewComponent extends Component<ComponentArgs> {}
